import React, { useEffect, useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { getCourseSubjects, getLevels } from '../../actions/miscellaneousActions'
import provinces from '../provinces.json'
import towns from '../towns.json'
import useAuth from '../../context/auth/useAuth'
import { getScheduledInterviewsByCandidate } from '../../actions/choosesActions'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction"
import '@fullcalendar/bootstrap5/main.css'
import '@fullcalendar/daygrid/main.css'
import esLocale from '@fullcalendar/core/locales/es'
import InterviewSection from '../jitsi/InterviewSection'
import { capitalizeFirstCharacter } from '../../utils'

export default function CandidateCalendar({visible, setVisible}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
	const {client} = useAuth()
    
    const calendar = useRef(null)

    const {levels, subjects} = useSelector(state => state.miscellaneous)
    const {schedule} = useSelector(state => state.chooses)
    const [isMeetingVisible, setIsMeetingVisible] = useState(false); // Controla si la reunión de Jitsi se muestra

    const [selectedEvent, setSelectedEvent] = useState(null)
    const [interviewShow, setInterviewShow] = useState(false)

    const handleEventClick = (e) => {
        if (e.event._def?.extendedProps?.type !== "choose") {
            setSelectedEvent(e.event._def?.extendedProps)
            setInterviewShow(true)
        }
    }
    
    useEffect(() => {
        if (client?.id && visible) {
            dispatch(getLevels())
            dispatch(getCourseSubjects())
            dispatch(getScheduledInterviewsByCandidate(client.id))
        }
    }, [visible, client, dispatch])

    return (
        <>
            <Modal show={visible} onHide={() => setVisible(false)} size='xl'>
                <Modal.Header closeButton/>
                <Modal.Body>
                    <FullCalendar
                        displayEventTime={false}
                        ref={calendar}
                        height={'auto'}
                        fixedWeekCount={false}
                        locale={esLocale}
                        weekends={true}
                        plugins={[dayGridPlugin, interactionPlugin]}
                        headerToolbar={{
                            start: 'prev',
                            center: 'title',
                            end: 'next',
                        }}
                        events={schedule?.map(s => {
                            let eventDate = new Date(s.day)
                            eventDate.setHours(s.hour.split(':')[0])
                            eventDate.setMinutes(s.hour.split(':')[1])
                            return {...s, title: `${s.school?.name || ''} ${s.hour}`, start: eventDate, classNames: s.accepted ? 'accepted' : 'pending'}
                        })}
                        eventClick={handleEventClick}
                    />
                </Modal.Body>
            </Modal>
            <Modal show={interviewShow} onHide={() => {setSelectedEvent(null);setInterviewShow(false)}}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedEvent?.selection?.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.school")}
                            <small>{selectedEvent?.school?.name || ''}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("school.selection.datetime")}
                            <small>{selectedEvent?.day ? new Date(selectedEvent?.day).toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric'}) : ''} {selectedEvent?.hour || ''}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.specialty")}
                            <small>{capitalizeFirstCharacter(levels?.find(l => l.id === selectedEvent?.selection?.specialty)?.label)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t(selectedEvent?.selection?.specialty == 1 ? "profile.candidate.position" : "selection.subject")}
                            <small>{t("subjects." + subjects?.find(s => s.id === selectedEvent?.selection?.subject)?.label)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.shortIncorporationDate")}
                            <small>{`${String(new Date(selectedEvent?.selection?.incorporationDate).getDate()).padStart(2, '0')}/${String(new Date(selectedEvent?.selection?.incorporationDate).getMonth() + 1).padStart(2, '0')}/${new Date(selectedEvent?.selection?.incorporationDate).getFullYear()}`}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.salary")}
                            <small>{selectedEvent?.selection?.salary || t("selection.byAgreement")}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.contractType")}
                            <small>{t("profile.candidate." + selectedEvent?.selection?.contractType)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("profile.candidate.idealPosition.workDay.label")}
                            <small>{t("profile.candidate.idealPosition.workDay." + selectedEvent?.selection?.workdayType)}</small>
                        </div>
                    </div>
                    {
                        selectedEvent?.school
                        ?
                            <>
                                <div className='py-2 px-3'>
                                    <div className='d-flex justify-content-between'>
                                        {t("users.town")}
                                        <small>{towns?.find(p => p.value === selectedEvent?.school?.town)?.label}</small>
                                    </div>
                                </div>
                                <div className='py-2 px-3 bg-grey'>
                                    <div className='d-flex justify-content-between'>
                                        {t("users.province")}
                                        <small>{provinces?.find(p => p.value === selectedEvent?.school?.province)?.label}</small>
                                    </div>
                                </div>
                                <div className='py-2 px-3'>
                                    <div className='d-flex justify-content-between'>
                                        {t("selection.schoolType")}
                                        <small>{t("school.typeschool." + selectedEvent?.school?.typeschool)}</small>
                                    </div>
                                </div>
                            </>
                        :
                            <></>
                    }
                    {
                        selectedEvent?.day && !(new Date(selectedEvent?.day) < new Date())
                        ?
                            <div className='mt-4 d-grid gap-2'>
                                <Button variant="primary" type="button" onClick={() => {setIsMeetingVisible(true); setInterviewShow(false); setVisible(false)}}>{t("selection.openMeeting")}</Button>
                            </div>
                        :
                            <></>
                    }
                </Modal.Body>
            </Modal>
            <Modal show={isMeetingVisible} onHide={() => {setIsMeetingVisible(false)}} fullscreen={true}>
                <Modal.Header closeButton><h4>{t("selection.submenu.interview")}</h4></Modal.Header>
                <Modal.Body>
                    <InterviewSection choose={selectedEvent?.choose} nameSend={client?.firstname+' '+client?.lastname} typeuser={'candidate'} t={t} />
                </Modal.Body>
            </Modal>
        </>
    )
}